<template>
  <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="pl-3 edit-news">
    <v-container class="custom-container responsive-height">
      <v-row>
        <v-col cols="12">
          <v-card-title class="pb-0">
            Update USD TO INR
          </v-card-title>
        </v-col>

        <v-col cols="12">
          <v-card class="deposit-form px-5" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
            <v-row dense>
              <v-col cols="12" xl="7" lg="8" md="9" sm="10" class="mb-2">
                <fieldset>
                  <legend>Currency</legend>
                  <!-- v-model bind to computed property for two-way binding -->
                  <v-text-field
                    :disabled="$canRoute('currency-usd-to-inr') !== 1"
                    v-model="inrRate"
                    label="USD TO INR"
                    single-line
                    solo
                    hide-details
                    class="custom-select"
                  ></v-text-field>
                </fieldset>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="$canRoute('currency-usd-to-inr') === 1">
          <v-btn
            large
            tile
            elevation="0"
            class="ml-5 text-capitalize btn-account"
            color="greenMain"
            @click="submitForm"
          >
            Submit
          </v-btn>
          <v-btn
            large
            tile
            elevation="0"
            class="ml-3 text-capitalize btn-account"
            color="#FF567F"
            @click="resetForm"
          >
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CURRENCY__ACTIONS } from "@/store/action-types";

export default {
  computed: {
    ...mapState("currencies", ["usdtoinrcurrency"]),

    inrRate: {
      get() {
        return this.usdtoinrcurrency?.value || "";
      },
      set(newVal) {
        if (this.usdtoinrcurrency) {
          this.usdtoinrcurrency.value = newVal;
        }
      },
    },
  },

  methods: {
    ...mapActions("currencies", [
      CURRENCY__ACTIONS.GETCURRECNCYUSDT,
      CURRENCY__ACTIONS.UPDTECURRENCYUSDT,
    ]),

    async submitForm() {
      if (!this.usdtoinrcurrency) return;

      const payload = {
        id: this.usdtoinrcurrency.id,
        value: this.usdtoinrcurrency.value,
      };
     // console.log("idvalue:", payload);
      await this[CURRENCY__ACTIONS.UPDTECURRENCYUSDT](payload);
    },

    resetForm() {
      if (this.usdtoinrcurrency) {
        this.usdtoinrcurrency.value = "";
      }
    },
  },

  async created() {
    await this[CURRENCY__ACTIONS.GETCURRECNCYUSDT]();
    // console.log("INR rate fetched:", this.usdtoinrcurrency);
  },
};
</script>
